import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPencilWithALine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M19.957 4.043a3.83 3.83 0 0 0-5.414 0l-9.332 9.332a5 5 0 0 0-1.208 1.955l-1.385 4.155c-.391 1.173.724 2.288 1.897 1.898l4.156-1.386a5 5 0 0 0 1.954-1.207l9.332-9.333a3.83 3.83 0 0 0 0-5.414m-4 1.414a1.828 1.828 0 0 1 2.586 2.586l-9.332 9.332a3 3 0 0 1-1.173.725l-3.207 1.069 1.07-3.207a3 3 0 0 1 .724-1.172z'
      clipRule='evenodd'
    />
    <path fill={props.color} d='M12 20a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2z' />
  </svg>
)
const ForwardRef = forwardRef(SvgPencilWithALine)
export default ForwardRef
